module.exports = __webpack_public_path__ + "img/ck-wiki-tip-btn.6c032b83.png";